import { backCameraKeywords } from "./backCameraKeywords";

export const isBackCameraLabel = (label: string) => {
  const lowercaseLabel = label.toLowerCase();

  return backCameraKeywords.some((keyword) => lowercaseLabel.includes(keyword));
};
